// @flow

import * as React from 'react';
import {TriggerTree} from '../helpers/commands/triggers';
import {TriggerResponse} from '../helpers/commands/fixture';

export const trigger = ({
  args,
  params,
  apiKey,
  setAllowInput,
}: {
  args: Array<string>,
  params: {[string]: string},
  apiKey: string,
  setAllowInput: (boolean) => void,
}) => {
  if (args.length !== 1) {
    setAllowInput(true);
    return 'Wrong number of arguments passed. Expected arguments: event';
  }

  if (!(args[0] in TriggerTree)) {
    setAllowInput(true);
    return `This is not a valid argument for stripe trigger: ${args[0]}`;
  }
  const fixtureConfig = TriggerTree[args[0]];

  return (
    <TriggerResponse
      fixtureConfig={fixtureConfig}
      api_key={apiKey}
      setAllowInput={setAllowInput}
    />
  );
};
